<rid-dictation-sentences
  class="h-dvh"
  [sentences]="['De leeuw slaapt onder de boom.', 'De zebra rent snel door het gras.', 'De tijger kijkt stil naar de rivier.']"
  (finished)="$router.navigate(['/mechanics/dictation'])"
/>
